import "./MessageThread.css";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import moment from "moment";

const MessageThread = (props) => {
  const [messageThreadData, setMessageThreadData] = useState([]);
  const [userId, setUserId] = useState(0);
  const [selectSortMenu, setSelectSortMenu] = useState(false);
  const [selectValue, setSelectValue] = useState("Newest");
  const filterValue = useRef(selectValue);
  const [searchParam, setSearchParam] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const searchQuery = useRef("");

  const handleSelectSort = () => {
    let selectMenuOpened = selectSortMenu;
    selectMenuOpened = !selectMenuOpened;
    setSelectSortMenu(selectMenuOpened);
  };


  const handleSelectValue = (val) => {
    setSelectValue(val);
    filterValue.current = val;
  };
  useEffect(() => {
    props.actSidebar(true);
    var userData = JSON.parse(localStorage.getItem("userData"));
    setUserId(userData.id);
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      getMessageThread();
    }
    // eslint-disable-next-line
  }, [searchParam, selectValue]);

  const functionFetchData = () => {
    if (searchQuery.current.value.trim().length >= 3) {
      setIsLoading(true);
    }
    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "messages/getTherapistThread", { searchPar: searchQuery.current.value.trim(), selVal: filterValue.current })
        .then((res) => {
          if (res.data.responseData.length !== 0 && res.data.responseData !== undefined) {
            setMessageThreadData(res.data.responseData);
            props.isThreadLoaded(true);
          } else{
            setMessageThreadData(
              [{
                id: 0,
                patient_id: 0,
                program_id: 0,
                from_user: 0,
                message: "",
                attachment: "",
                send_datetime: new Date().toISOString(),
                unread_count: 0,
                is_read: 0,
                read_datetime: "0000-00-00 00:00:00",
                patient_name: "No Patient Found",
              }]
            )
            props.isThreadLoaded(true);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.error(error);
        });
  }

  const searchFunction = () =>{
    let searchPar = searchQuery.current.value.trim();
    let messageSearching = messageThreadData.slice();
    const matchedPatient = messageSearching.filter(patient => patient.patient_name.toLowerCase().includes(searchPar.toLowerCase()));
    if (matchedPatient && matchedPatient.length !== 0) {
      if (matchedPatient.length === 1) {
        functionFetchData();
      } else {
        setMessageThreadData(matchedPatient);
        props.isThreadLoaded(true);
      }
    } else {
      setMessageThreadData(
        [{
          id: 0,
          patient_id: 0,
          program_id: 0,
          from_user: 0,
          message: "",
          attachment: "",
          send_datetime: new Date().toISOString(),
          unread_count: 0,
          is_read: 0,
          read_datetime: "0000-00-00 00:00:00",
          patient_name: "No Patient Found",
        }]
      )
      functionFetchData();
      props.isThreadLoaded(true);
    }
  }

  const getMessageThread = () => {
    let searchPar = searchQuery.current.value.trim();
    // if (messageThreadData.length > 1 && searchQuery.current.value.length <= 2 && searchPar.length <= 2) {
    //   let messageSorting = messageThreadData.slice();
    //   if (filterValue.current === "Oldest") {
    //     // console.log(messageSorting, "ttt");
    //     messageSorting.sort((a, b) => moment(new Date(a.send_datetime)).valueOf() - moment(new Date(b.send_datetime)).valueOf());
    //   } else if (filterValue.current === "Newest") {
    //     messageSorting.sort((a, b) => moment(new Date(b.send_datetime)).valueOf() - moment(new Date(a.send_datetime)).valueOf());
    //   } else if (filterValue.current === "Name") {
    //     messageSorting.sort((a, b) => a.patient_name.localeCompare(b.patient_name));
    //   } else {
    //     messageSorting.sort((a, b) => moment(new Date(a.send_datetime)).valueOf() - moment(new Date(b.send_datetime)).valueOf());
    //   }
    //   setMessageThreadData(messageSorting);
    //   props.isThreadLoaded(true);
    // } else 
    if (searchPar.length >= 3 || searchQuery.current.value.length >= 3) {
      searchFunction();
    } else {
      functionFetchData();
    }
  };

  useEffect(() => {
    //
    var userData = JSON.parse(localStorage.getItem("userData"));
    const eventSource = new EventSource(
      window.ajaxLink + "updatesse/events?observeData=patientThread&valueName=" + userData.id.toString()
    );
    eventSource.onmessage = (e) => {
      if (e.data.toString().toLowerCase() == "update") {
        getMessageThread();
      }
    };
    return () => {
      eventSource.close();
    };
    // eslint-disable-next-line
  }, []);

  const handleSearchQuery = (value) => {
    if (value && value.length >= 3) {
      setSearchParam(value);
    } else if (value === "") {
      setSearchParam("");
      if (value.length === 2) {
        setIsLoading(true);
      }
      functionFetchData();
    }
  };
  return (
    <div className="message_thread_container">
      {/* <div className="message_search_container"></div> */}
      <input
        type="text"
        placeholder={"Search"}
        className="message_search_bar"
        ref={searchQuery}
        onChange={() => handleSearchQuery(searchQuery.current.value)}
      />
      {messageThreadData.length > 0 && (
        <div className="sort_thread_container">
          <span>Sort by</span>
          <div className="sort_select_container" onClick={handleSelectSort}>
            <div className="select_value">{filterValue.current}</div> <div className="down_arr_blue"></div>
            <div
              className="options_hold sort_sel_container "
              style={selectSortMenu ? { display: "block" } : { display: "none" }}
            >
              <div className="sort_sel_option" onClick={() => handleSelectValue("Name")}>
                Name
              </div>
              <div className="sort_sel_option" onClick={() => handleSelectValue("Newest")}>
                Newest
              </div>
              <div className="sort_sel_option" onClick={() => handleSelectValue("Oldest")}>
                Oldest
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="thread_container">
        <div className="thread_scrollable">
        {!isLoading ? (
        <>
          {messageThreadData
            .filter(data => data.message !== "No messages")
            .map((data, i) =>
              data ? (
              <div
                key={i}
                className="thread_one_message"
                style={{ cursor: data.patient_name !== "No Patient Found" && "pointer"}}
                onClick={() =>
                  data.patient_name !== "No Patient Found" &&
                  props.handleUserMessages(data.patient_id, data.from_user, data.patient_name, data.program_id)
                }
              >
                <div onClick={() => data.patient_name !== "No Patient Found" && getMessageThread()}>
                  <div className="thread_message_header">
                    <div className="thread_sender_name">{data.patient_name}</div>
                    {data.message !== "No messages" && data.patient_name !== "No Patient Found" ? (
                      <div className="thread_date">{moment(data.send_datetime).format("l")}</div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="thread_message_body">
                    <div className="tmessage">
                      {(data.from_user === userId ? "you: " : "") + data.message}
                      {data.message === "" && data.attachment !== "" ? <div className="picture_tmess">Picture</div> : ""}
                    </div>
                    {data.from_user === userId && data.unread_count === 0 ? (
                      <div
                        className={"message_status" + (data.is_read === 0 ? " not_readed_message" : " readed_message")}
                      ></div>
                    ) : data.unread_count > 0 ? (
                      <div className="unread_messages_count">
                        <div className="unread_messages_number">{data.unread_count}</div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            ) : (
              ""
              )
              )}
        </>
        ):(
          <div className="limited_page_loader"></div>
        ) }
        </div>
      </div>
    </div>
  );
};

export default MessageThread;
